import { AccredibleThemeableMultipleSearchInputComponentModule } from '@accredible-frontend-v2/forms/multiple-search-input';
import { AccredibleObjectWithId } from '@accredible-frontend-v2/models';
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { DirectoryStoreActions } from '../../../../../../core/stores/directory/directory.actions';
import { DirectoryState } from '../../../../../../core/stores/directory/directory.reducer';
import {
  selectSkillCategories,
  selectSkillCategoryMap,
} from '../../../../../../core/stores/directory/directory.selectors';
import { FilterService } from '../../../../services/filter.service';
import { SpotlightProfilesState } from '../../../../store/spotlight-profiles/spotlight-profiles.reducer';
import { selectSpotlightProfilesFiltersSkillCategories } from '../../../../store/spotlight-profiles/spotlight-profiles.selectors';

@Component({
  selector: 'sl-profile-list-skill-category-filter',
  standalone: true,
  imports: [
    CommonModule,
    AccredibleThemeableMultipleSearchInputComponentModule,
    TranslocoDirective,
  ],
  templateUrl: './profile-list-skill-category-filter.component.html',
  styleUrl: './profile-list-skill-category-filter.component.scss',
})
export class ProfileListSkillCategoryFilterComponent implements OnInit {
  private readonly _directoryStore = inject(Store<DirectoryState>);
  private readonly _spotlightProfileStore = inject(Store<SpotlightProfilesState>);
  private readonly _filter = inject(FilterService);

  private readonly skillCategoryMap$ = this._directoryStore.select(selectSkillCategoryMap);
  private readonly selectedSkillCategoryIds$ = this._spotlightProfileStore.select(
    selectSpotlightProfilesFiltersSkillCategories,
  );

  readonly skillCategories$ = this._directoryStore.select(selectSkillCategories) as Observable<
    AccredibleObjectWithId[]
  >;

  readonly selectedSkillCategories$ = combineLatest([
    this.selectedSkillCategoryIds$.pipe(filter(Boolean)),
    this.skillCategoryMap$.pipe(filter(Boolean)),
  ]).pipe(
    map(([selectedIds, skillCategoryMap]) => selectedIds.map((id) => skillCategoryMap[id])),
  ) as Observable<AccredibleObjectWithId[]>;

  ngOnInit(): void {
    this._directoryStore.dispatch(DirectoryStoreActions.loadSkillCategories());
  }

  onSelectedSkillCategoriesChange(skillCategories: AccredibleObjectWithId[]): void {
    this._filter.updateRouterQueryParams({
      categories: skillCategories.map((category) => category.id),
    });
  }
}
